import { Spinner } from 'react-bootstrap';
import IconifyIcon from '../../../wrappers/IconifyIcon';
import { useAuth } from '../../../../context/AuthContext';
import { canAccessWhatsApp } from '../../../../helpers/whatsapp';
import useWhatsAppGate from '../../../../hooks/useWhatsAppGate';
import WhatsAppSetupModal from '../../../whatsapp/WhatsAppSetupModal';
import WhatsAppToast from '../../../whatsapp/WhatsAppToast';

const WhatsAppNavButton = () => {
  const { admin } = useAuth();
  const {
    checking,
    showSetup,
    settings,
    toast,
    clearToast,
    openSetupIfNeeded,
    closeSetup,
    handleSaved,
  } = useWhatsAppGate(admin);

  if (!canAccessWhatsApp(admin)) return null;

  return (
    <>
      <WhatsAppToast toast={toast} onClose={clearToast} />
      <div className="topbar-item">
        <button
          type="button"
          className="topbar-button"
          onClick={openSetupIfNeeded}
          disabled={checking}
          aria-label="WhatsApp"
          title="WhatsApp"
        >
          {checking ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <IconifyIcon icon="bxl:whatsapp" className="fs-24 align-middle" />
          )}
        </button>
      </div>
      <WhatsAppSetupModal
        show={showSetup}
        settings={settings}
        onCancel={closeSetup}
        onSaved={handleSaved}
      />
    </>
  );
};

export default WhatsAppNavButton;
